import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Globals } from '@core/globals';
import { CarValuationService } from '@services/car-valuation.service';

export const carValuationGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const globals = inject(Globals);
  const carValuationService = inject(CarValuationService);
  const currentPath = route.routeConfig?.path;

  switch (currentPath) {
    case 'oceneni-vozu/vybava':
      if (carValuationService.carValuationData().specificationCarValid) return true;
      break;
    case 'oceneni-vozu/stav-auta':
      if (carValuationService.carValuationData().equipmentValid) return true;
      break;
    case 'oceneni-vozu/fotografie':
      if (carValuationService.carValuationData().carConditionValid) return true;
      break;
    case 'oceneni-vozu/kontaktni-udaje':
      if (carValuationService.carValuationData().carPhotosValid) return true;
      break;
    default:
      return true;
  }

  router.navigate([globals.routes()['carValuationSpecification'].url]);
  return false;
};
